export const BIRDVIEW_LAYOUT_COLUMN = {
  left: 'left',
  right: 'right',
}

export const BIRDVIEW_LAYOUT_COLUMN_KEYS = [
  BIRDVIEW_LAYOUT_COLUMN.left,
  BIRDVIEW_LAYOUT_COLUMN.right,
]

export const BIRDVIEW_SORTABLE_WIDGET_TYPE = 'birdviewWidget'
